//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tweetsAPI from "./../apis/tweets";
import { mapState } from "vuex";
import { Toast } from "./../utils/helpers";

export default {
  name: "CreateTweet",
  computed: {
    ...mapState(["currentUser"]),
  },
  data() {
    return {
      description: "",
    };
  },
  methods: {
    async handleSubmit() {
      try {
        const { data } = await tweetsAPI.createTweets({
          description: this.description,
        });

        if (data.status === "error") {
          throw new Error(data.message);
        }

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        this.$emit("modal-create-tweet");
        this.description = ""; // 將表單內的資料清空
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
  },
};
